import angular from 'angular';

module.exports = angular.module('market.routes.offer-terms', [
  require('angular-ui-router')
])
.config(function($stateProvider) {
  $stateProvider.state('offer-terms', {
    parent: 'root',
    url: '/offerterms',
    templateUrl: '/templates/common/offer_terms.html',
    data: {
      meta: {
        titleSuffix: " | Offer Terms",
      }
    },
  });
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/routes/offer-terms.js
 **/